module.exports = __webpack_public_path__ + "media/images/emoticons/night-7998ab1c1d4bdbaeb93e88bfe51799d2.gif";